/**
 * @generated SignedSource<<e9be78922afaa48a23b038ee93bc35df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type tsShopUpgradeMutation$variables = {
  id: number;
  token: string;
  secret: string;
};
export type tsShopUpgradeMutation$data = {
  readonly upgradeStore: {
    readonly id: string;
    readonly v2: boolean;
  };
};
export type tsShopUpgradeMutation = {
  variables: tsShopUpgradeMutation$variables;
  response: tsShopUpgradeMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "secret"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "secret",
        "variableName": "secret"
      },
      {
        "kind": "Variable",
        "name": "token",
        "variableName": "token"
      }
    ],
    "concreteType": "Shop",
    "kind": "LinkedField",
    "name": "upgradeStore",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "v2",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "tsShopUpgradeMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "tsShopUpgradeMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "48e3cbb6b03fef804ef77a9861cf97d9",
    "id": null,
    "metadata": {},
    "name": "tsShopUpgradeMutation",
    "operationKind": "mutation",
    "text": "mutation tsShopUpgradeMutation(\n  $id: Int!\n  $token: String!\n  $secret: String!\n) {\n  upgradeStore(id: $id, token: $token, secret: $secret) {\n    id\n    v2\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe4e14ccfe25fba76d47b695b13086ab";

export default node;
